import { TeContainer, TeIcon, TeText } from '@topcon/tuicl-react';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';

interface Props {
  code: 400 | 401 | 404;
}

/** Error module - displays navigational errors */
function Error({ code }: Props) {
  const getCode = () => {
    return { '400': '400 Bad request', '401': '401 Unauthorized', '404': '404 Not Found' }[code];
  };

  const getIcon = () => {
    return { '400': 'error', '401': 'lock', '404': 'psychology_alt' }[code] as IconName;
  };

  return (
    <TeContainer grow alignItems="center" justifyContent="center">
      <TeIcon size="xl" name={getIcon()} />
      <TeText size={32} weight={700}>
        {getCode()}
      </TeText>
    </TeContainer>
  );
}

export default Error;
